import { AppDispatch } from '@/store/index';
import { ReportSlice } from '@/store/reducers/ReportReducer';
import { ReportsService } from '@services/ReportsService';
import { sendModalMsg } from '@srm/ui/lib/modalMessages';
import { sendNotification } from '@srm/ui/lib/notifications';
import { errorText, errorTraceId } from '@srm/core/errors';

export const ReportActionCreators = {
    fetchReportScheme: (formName: string) => async (dispatch: AppDispatch) => {
        try {
            const response = await ReportsService.getScheme(formName);
            dispatch(ReportSlice.actions.successLoadScheme(response.data));
        } catch (e) {
            let error = e as string[];
            sendModalMsg({
                message: error,
                type: 'error',
            });
        }
    },

    fetchReportData: (folder: string, name: string) => async (dispatch: AppDispatch) => {
        try {
            const response = await ReportsService.getData(folder, name);
            dispatch(ReportSlice.actions.successLoadData(response.data));
        } catch (e) {
            let error = e as string[];
            sendModalMsg({
                message: error,
                type: 'error',
            });
        }
    },

    fetchReportFormats: (folder: string, name: string) => async (dispatch: AppDispatch) => {
        try {
            const response = await ReportsService.getFormats(folder, name);
            dispatch(ReportSlice.actions.successLoadTypes(response.data));
        } catch (e) {
            let error = e as string[];
            sendModalMsg({
                message: error,
                type: 'error',
            });
        }
    },

    resetReport: () => async (dispatch: AppDispatch) => {
        dispatch(ReportSlice.actions.reset());
    },

    /** Выгрузка ранее построенного отчёта: данные сервер заново не запрашивает. */
    downloadReportRun: (runId: string, format: string) => async (dispatch: AppDispatch) => {
        try {
            dispatch(ReportSlice.actions.setIsBuilding(true));
            await ReportsService.downloadRunFile(runId, format);
        } catch (e) {
            sendNotification({
                message: errorText(e, 'Не удалось выгрузить отчёт.'),
                variant: 'red',
                traceId: errorTraceId(e),
            });
        } finally {
            dispatch(ReportSlice.actions.setIsBuilding(false));
        }
    },

};
